import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
export function SharedNavbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Acasă',
    path: '/acasa'
  }, {
    name: 'AHA Academy',
    path: '/ahaacademy'
  }, {
    name: 'Despre Mine',
    path: '/despremine'
  }, {
    name: 'Resurse Cadou',
    path: '/resursegratuite'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  const sesiuneCadouLink = '/sesiune1la1';
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-ivory/85 backdrop-blur-md border-b border-forest/10 ${isScrolled ? 'shadow-sm py-4' : 'py-6'}`} data-id="element-770">
      <div className="max-w-[1200px] mx-auto px-6 md:px-8 flex items-center justify-between" data-id="element-771">
        {/* Logo */}
        <NavLink to="/acasa" className="flex items-center no-underline" aria-label="AHA - Anima Healing Academy" data-id="element-772">
          <img src="https://cdn.magicpatterns.com/uploads/d1LgWwBPnh5dzxqudPx3b6/Screenshot_2026-05-22_at_19.05.11.png" alt="AHA - Anima Healing Academy" className="h-14 md:h-16 w-auto object-contain" data-id="element-773" />
        </NavLink>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center gap-6 xl:gap-8" data-id="element-774">
          {navLinks.map(link => <NavLink key={link.name} to={link.path} className={({
          isActive
        }) => `font-display text-sm font-medium tracking-wide transition-colors relative py-2 ${isActive ? 'text-forest' : 'text-charcoal/70 hover:text-forest'}`} data-id="element-775">
              {({
            isActive
          }) => <>
                  {link.name}
                  {isActive && <span className="absolute bottom-0 left-0 w-full h-0.5 bg-gold rounded-full" data-id="element-776" />}
                </>}
            </NavLink>)}
        </nav>

        {/* CTA Button (Desktop) */}
        <div className="hidden lg:block" data-id="element-777">
          <NavLink to={sesiuneCadouLink} className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-forest text-ivory font-display text-sm font-medium hover:bg-forest-light transition-colors shadow-md shadow-forest/10 no-underline" data-id="element-778">
            Sesiune Cadou!
          </NavLink>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-forest p-2 -mr-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-779">
          {isMobileMenuOpen ? <X size={24} data-id="element-780" /> : <Menu size={24} data-id="element-781" />}
        </button>
      </div>

      {/* Mobile Menu Panel */}
      <div className={`lg:hidden absolute top-full left-0 w-full bg-ivory shadow-lg transition-all duration-300 overflow-hidden ${isMobileMenuOpen ? 'max-h-[600px] border-t border-forest/10' : 'max-h-0'}`} data-id="element-782">
        <div className="px-6 py-6 flex flex-col gap-4" data-id="element-783">
          {navLinks.map(link => <NavLink key={link.name} to={link.path} onClick={() => setIsMobileMenuOpen(false)} className={({
          isActive
        }) => `font-display text-lg font-medium py-2 border-b border-forest/5 ${isActive ? 'text-forest' : 'text-charcoal/70'}`} data-id="element-784">
              {link.name}
            </NavLink>)}
          <NavLink to={sesiuneCadouLink} onClick={() => setIsMobileMenuOpen(false)} className="mt-4 inline-flex items-center justify-center px-6 py-3 rounded-full bg-forest text-ivory font-display text-base font-medium text-center no-underline" data-id="element-785">
            Sesiune Cadou!
          </NavLink>
        </div>
      </div>
    </header>;
}